export enum EVENT_NAME_OBJECT_MESSAGE {
  CREATE = 'Created',
  UPDATE = 'Updated',
  DELETE = 'Deleted',
}
